// extracted by mini-css-extract-plugin
export default {"wrapper":"small-loading_wrapper__7o9hj","icon":"small-loading_icon__0b5Lc","spin":"small-loading_spin__JhUDQ"};